import { Button, LinkButton, styled, SxProps } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { channel } from "@tm/models"
import { classes, encodeUniqueId, renderRoute, uniqueId } from "@tm/utils"
import { forwardRef, useCallback, useMemo } from "react"
import { useHistory, useParams } from "react-router"
import { offersWidgetClasses, offersWidgetName, offersWidgetSlots } from "@tm/themes"
import { getBundleParams } from "../../../utils"
import { useOffersStore } from "../store"
import { openPartsList } from "../helpers"

const GENERATED_WORKTASK_ID = uniqueId()

type OfferDetailsButtonProps = {
    className?: string
    sx?: SxProps
}

const OfferDetailsButtonComponent = forwardRef<HTMLButtonElement, OfferDetailsButtonProps>(({ className, sx }, ref) => {
    const { translateText } = useLocalization()
    const history = useHistory()
    const params = useParams<{ workTaskId?: string }>()
    const { selectedCategory, offersTabActive } = useOffersStore()

    const { detailsUrl: detailsRoute } = getBundleParams()

    const requestPartList = useCallback(
        (showAddToBasketMessage?: boolean) => {
            if (selectedCategory) {
                if (showAddToBasketMessage) {
                    channel("APP").publish("TOAST_MESSAGE/SHOW", { message: translateText(1728), skin: "success" })
                }
                openPartsList(history, GENERATED_WORKTASK_ID, selectedCategory)
            }
        },
        [history, selectedCategory, translateText]
    )

    const updateWorktaskTitle = useCallback(() => {
        channel("WORKTASK", GENERATED_WORKTASK_ID).publish("MODULE/CHANGED", {
            id: "offers",
            name: "offers",
            view: "{{1276}}",
        })
    }, [])

    const detailsUrl = useMemo(
        () => renderRoute(detailsRoute, { workTaskId: params.workTaskId ?? encodeUniqueId(GENERATED_WORKTASK_ID) }),
        [detailsRoute, params.workTaskId]
    )

    if (offersTabActive) {
        return (
            <LinkButton
                ref={ref}
                to={detailsUrl}
                onClick={updateWorktaskTitle}
                size="small"
                sx={sx}
                className={classes(offersWidgetClasses.detailsButton, className)}
            >
                {translateText(1275)}
            </LinkButton>
        )
    }

    return (
        <Button
            ref={ref}
            onClick={() => requestPartList()}
            size="small"
            disabled={!selectedCategory}
            sx={sx}
            className={classes(offersWidgetClasses.detailsButton, className)}
        >
            {translateText(1275)}
        </Button>
    )
})

export const OfferDetailsButton = styled(OfferDetailsButtonComponent, {
    name: offersWidgetName,
    slot: offersWidgetSlots.detailsButton,
    overridesResolver: (_, styles) => styles.detailsButton,
})({})
